import { TranslatePipe } from '../../filters/translate.pipe';
import { ListLanguageFlagsComponent } from '../../components/list-language-flags/list-language-flags.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import InstantBookingService from '../../services/instant-booking.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'table-bookings-instant',
	templateUrl: './table-bookings-instant.component.html',
	imports: [ CommonModule, TranslatePipe, ListLanguageFlagsComponent, FormsModule ]
})
export class TableBookingsInstantComponent implements OnInit {
	private instantBookingService: InstantBookingService = inject(InstantBookingService);
	
	@Input() bookings: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.handleBookingAccept = this.handleBookingAccept;
		this.vm.getPrescriptionDescription = this.getPrescriptionDescription;
	}
	
	handleBookingAccept(booking) {
		if (booking.isAccepting) return;
		booking.isAccepting = true;
		
		this.instantBookingService.acceptPendingRequest(booking).catch(() => { booking.isAccepting = false; });
	}
	
	getPrescriptionDescription(booking) {
		if (booking.prescriptionRequest.prescription) {
			return booking.prescriptionRequest.prescription.drugName || booking.prescriptionRequest.prescription.ingredientName;
		}
		return (booking.prescriptionRequest.drug && booking.prescriptionRequest.drug.name)
			? (booking.prescriptionRequest.drug.name + ' ' + booking.prescriptionRequest.drug.amount)
			: booking.prescriptionRequest.drugIngredient.name;
	}
	
}